import { ReactNode, useEffect, useState } from "react"
import { StyledHeader } from "../components/StyledHeader"
import ApiService from "../services/ApiService"
import { rootStore } from "../StApp"
import insta_icon from '../assets/insta-ico.svg'
import linkedin_logo from '../assets/linkedin-ico.svg'
import { InviteStore } from "../stores/InviteStore"
import { observer } from "mobx-react-lite"
import { AppContact } from "../components/AppContact"
import { motion } from "framer-motion";
import { Transitions } from "../transitions/pageTransitions";
import Logger from "../services/Logger"

const CreateInviteInternal = observer(() => {

    const [store] = useState(new InviteStore())

    useEffect(() => {
        store.getLeftInvites()
    }, [])

    // const [inviteCode, setInviteCode] = useState('')

    // function getInviteCode(){
    //     ApiService.createInviteRequest({
    //         auth: rootStore.mainStore.token,
    //         data: {
    //             uid: rootStore.mainStore.uid!,
    //             ig: 'dummy',
    //             linked_in: '',
    //             video: false
    //         }
    //     }).then(resp=>{
    //         setInviteCode(resp.data)
    //     })
    // }

    async function shareInvite() {
        const shareData = {
            title: 'Invite to SaytoMe',
            text: `Please use invite code ${store.inviteCode}`,
            url: `/stapp/register`
        }

        Logger.debug(shareData.url, 'URL')

        try {
            await navigator.share(shareData)
        } catch (err) {
            Logger.err(err,'Sharing Error')
        }
    }

    function getStatus(): ReactNode {

        // var x = store.instagram
        // x = store.linkedIn


        switch (store.createInviteProg) {

            case 'INIT': return 'Create Invite'
                break;
            case 'LOADING': return <progress className="pure-material-progress-circular" />
                break;
            case 'FAILED': return 'Create Invite'
                break;
            case 'SUCCESS': return 'Create Invite'

        }
    }

    return (
        <motion.div className='flex-column main-cont absolute '
            initial="initial"
            animate="in"
            exit="out"
            variants={Transitions.pageVariants}
            transition={Transitions.pageTransition}
        >
            <div style={{ position: 'absolute', top: 20, left: 20 }} >
                <StyledHeader heading='Create Invite' />
            </div>
            <div className='flex-column center-align card' style={{ borderRadius: 10, width: '60%', padding: 10 }} >
                <h5 style={{ textAlign: 'center' }} >Enter any of the Instagram or LinkedIn id of the user you're inviting</h5>
                <div className='flex-row center-align' >
                    <p>Instagram</p>
                    <img src={insta_icon} alt="" style={{ width: 30, height: 30 }} />
                </div>
                <input type="text" name="instagram" id="" onChange={e => store.updateInstagram(e.target.value)} />
                <div className='flex-row center-both' >
                    <div style={{ width: 20, height: 1, backgroundColor: 'gray', margin: 10 }}></div>
                    <p>Or</p>
                    <div style={{ width: 20, height: 1, backgroundColor: 'gray', margin: 10 }}></div>
                </div>
                <div className='flex-row center-align' >
                    <p>LinkedIn</p>
                    <img src={linkedin_logo} alt="" style={{ width: 30, height: 30 }} />
                </div>
                <input type="text" name="linkedIn" id="" onChange={e => store.updateLinkedIn(e.target.value)} />
                <button
                    className='button-5 button-fixed button-invite '
                    disabled={store.instagram == '' && store.linkedIn == ''}
                    onClick={() => store.createInvite()} >{getStatus()}</button>
                <p style={{ margin: 10, color: 'gray' }} >{store.leftInvites} Invites left</p>
            </div>
            <div className='flex-column' style={{ margin: 15 }} >
                <p>Invite Code is</p>
                <p style={{ fontSize: 25 }} >{store.inviteCode}</p>
            </div>
            { store.inviteCode.length > 1 && (<div className='flex-column center-both' onClick={shareInvite} >
                <span className="material-icons-outlined">
                    ios_share
                </span>
                <h4>Share</h4>
            </div>)}

        </motion.div>
    )
})

export const CreateInvite = () => {
    return (
        <div className='flex-column main-cont register' style={{ height: window.innerHeight }} >
            <CreateInviteInternal />
        </div>
    )
}